import React, {Fragment, useContext, useState} from "react";
import logo from "../../assets/suraj-logo.png";
import "./navbar.styles.scss";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {scroller} from "react-scroll";
import {UserContext} from "../../context/user.context";
import {signOutUser} from "../../utils/firebase/firebase.utils";

const NAV_LINKS = ["home", "about", "project", "experience", "contact", "blog"];

// Links that are their own page (routed) rather than a scroll target.
const ROUTE_LINKS = {blog: "/blog"};

const Navbar = () => {
  const {currentUser} = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleHomeClick = (elementName) => {
    setMenuOpen(false);

    // Routed pages (e.g. blog) navigate instead of scrolling.
    if (ROUTE_LINKS[elementName]) {
      navigate(ROUTE_LINKS[elementName]);
      window.scrollTo(0, 0);
      return;
    }

    if (location.pathname === "/") {
      scrollToElement(elementName);
    } else {
      navigate("/");
      setTimeout(() => {
        scrollToElement(elementName);
      }, 50);
    }
  };

  const scrollToElement = (element) => {
    const scrollDurationPerPx = 0.5;
    const currentScrollPosition = window.pageYOffset;
    const targetScrollPosition = document.getElementById(element).offsetTop;
    const distance = Math.abs(targetScrollPosition - currentScrollPosition);
    const duration = distance * scrollDurationPerPx;

    scroller.scrollTo(element, {
      duration: duration,
      smooth: true,
    });
  };

  // When signed in, show a trimmed set — but keep Blog reachable so admins
  // can jump to authoring.
  const visibleLinks = currentUser ? ["home", "blog"] : NAV_LINKS;

  const handleSignOut = async () => {
    setMenuOpen(false);
    try {
      await signOutUser();
      navigate("/");
    } catch (error) {
      console.error("Failed to sign out", error);
    }
  };

  return (
    <Fragment>
      <div className="nav-container">
        <div className="nav-flex">
          <div className="nav-logo" onClick={() => handleHomeClick("home")}>
            <img src={logo} alt="Suraj Verma logo"/>
          </div>

          <button
            className={`nav-toggle ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle navigation menu"
            aria-expanded={menuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-links-container ${menuOpen ? "open" : ""}`}>
            {visibleLinks.map((link) => (
              <div
                key={link}
                className="nav-link"
                onClick={() => handleHomeClick(link)}
              >
                {link}
              </div>
            ))}

            {currentUser ? (
              <button className="nav-signout" onClick={handleSignOut}>
                Sign Out
              </button>
            ) : (
              <button
                className="nav-signin"
                onClick={() => {
                  setMenuOpen(false);
                  navigate("/login");
                  window.scrollTo(0, 0);
                }}
              >
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>
      <Outlet/>
    </Fragment>
  );
};

export default Navbar;
